import { memo } from 'react';
import {
  EstateTaskIdentifier,
  EstateTaskInstance_GetAllEstateTaskInstancesWithDeadlineByPortalIdQuery,
} from 'queries';

import AssignedTaskStatus from 'pages/assigned-tasks-page/components/assigned-task-status';
import AssignedTrusuiteSearchTaskStatus from 'pages/assigned-tasks-page/components/assigned-trusuite-search-task-status';
import UnassignedTaskStatus from 'pages/estate-checklist/components/unassigned-task-status';

type DeadlineTrackerStatusProps = {
  estateTaskInstance: EstateTaskInstance_GetAllEstateTaskInstancesWithDeadlineByPortalIdQuery['data'][0];
  handleOpenAssignedTaskDrawer: () => void;
};

export const DeadlineTrackerStatus = memo(
  ({ estateTaskInstance, handleOpenAssignedTaskDrawer }: DeadlineTrackerStatusProps) => {
    if (estateTaskInstance.identifier === EstateTaskIdentifier.TrusuiteSearch) {
      return <AssignedTrusuiteSearchTaskStatus estateStatus={estateTaskInstance.estate.status} />;
    } else if (estateTaskInstance.estateWorkItemId) {
      return (
        <AssignedTaskStatus
          estateWorkItemStatus={estateTaskInstance.estateWorkItem!.status}
          estateWorkItemSubStatus={estateTaskInstance.estateWorkItem!.subStatus}
          onClick={handleOpenAssignedTaskDrawer}
        />
      );
    }

    return <UnassignedTaskStatus estateTaskInstanceStatus={estateTaskInstance.status} />;
  },
);
